// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"2a112a43","725":"bea736be"}[chunkId] + ".chunk.css";
};